<template>
  <div class="systemRole">
    <div class="role-auth-aside">
      <div key="0" class="role-auth-table">
        <div class="role-auth-bar">
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable>
            <template #prefix>
              <i class="el-icon-search el-input__icon" />
            </template>
          </el-input>
          <i v-if="addSysRoleConfig" class="el-icon-circle-plus-outline"
            style="cursor: pointer" @click="addRoleHandler()"></i>
        </div>
        <roleTree
          ref="roletree"
          :roleType="roleType"
          @empty="empty"
          @queryPreson="queryPreson"
          @setRoleTreeData="setRoleTreeData"
          @modellist="modellist"
          @setSystemAddOption="setSystemAddOption"
          @setLoading="setLoading"
        ></roleTree>
      </div>
    </div>
    <!-- 右侧内容区域 -->
    <div class="role-auth-content">
      <div v-if="systemAddOption.roleID && systemAddOption.$isOperation != 1" style="height:100%">
        <template>
          <div class="role-auth-content-top">
            <el-radio-group v-model="tabPosition" size="small">
              <el-radio-button label="权限分配">权限分配</el-radio-button>
              <el-radio-button label="成员信息">成员信息</el-radio-button>
            </el-radio-group>
            <div v-if="tabPosition == '成员信息'" style="display: flex">
              <el-button v-if="addRoleUserConfig" type="primary" size="small"
                @click="addRolePersonHandler">
                添加人员
              </el-button>
              <el-button v-if="deleRoleUserConfig" type="danger" size="small" plain
                @click="batchDelete">
                批量删除
              </el-button>
              <el-input v-model.trim="keyword" placeholder="请输入人员姓名或手机号" size="small" style="margin-left:10px"
                clearable @keyup.enter.native="search">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div v-else style="display: flex">
              <el-button v-if="systemAddOption.roleName != '系统管理员'" type="default" icon="el-icon-document-copy"
                size="small" @click="copyToOtherSysRole">
                复制设置到其他角色
              </el-button>
              <el-button v-if="systemAddOption.roleName != '系统管理员'" :disabled="isDisabled" type="primary" size="small"
                @click="submitModulesHandler">
                提交权限
              </el-button>
            </div>
          </div>
          <div v-if="tabPosition == '权限分配'" v-loading="tableLoading" class="role-auth-modules-nolist"
            element-loading-text="数据加载中...">
            <el-table :key="Skey" :indent="16" :tree-props="moduleTreeProp" :data="moduleTree" :row-style="rowStyle"
              :cell-style="cellStyle" :show-header="false" :header-cell-style="headerStyle" row-key="permissionId"
              border height="100%" default-expand-all>
              <template slot="empty">
                <img :src="zanwu" alt="图片" />
                <p style="font-size:16px;color:#000;">
                  暂无数据
                </p>
              </template>
              <el-table-column class-name="table-module-name" width="400px">
                <template #default="{ row }">
                  <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0"
                    :disabled="systemAddOption.roleName == '系统管理员'" :indeterminate="getIndeterminate(row)"
                    @change="setTreeLimit(row)">
                    {{ row.permissionName }}
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column class-name="table-module-name">
                <template #default="{ row }">
                  <div v-for="(item, index) in row.buttonList" :key="index" style="margin-right: 30px; width: 150px">
                    <el-checkbox v-model="item.isChecked" :true-label="1" :false-label="0"
                      :disabled="systemAddOption.roleName == '系统管理员'" @change="checkboxChange(item)">
                      {{ item.permissionName }}
                    </el-checkbox>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tabPosition == '成员信息'" class="peopleTable">
            <rolePersonTab
              ref="rolePersonTab"
              @delRolePersonHandler="delRolePersonHandler"
              @setSelectionData="setSelectionData"
            ></rolePersonTab>
          </div>
        </template>
      </div>
      <template v-else>
        <div class="empty mt-40">
          请选择左侧角色
        </div>
      </template>
    </div>
    <selectSysRoleDlg ref="selectSysRoleDlg" />
  </div>
</template>

<script>
import { disablePrompt, checkPermission } from "@/CommonDP/utils/routeAuth";
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import { getTreeData } from "@/CommonDP/utils/tree";
import roleTree from '@/CommonDP/pages/mainMg/settings/permission/components/roleTree';
import selectSysRoleDlg from '@/CommonDP/pages/mainMg/settings/permission/components/selectSysRoleDlg';
import rolePersonTab from '@/CommonDP/pages/mainMg/settings/permission/components/rolePersonTab';

export default {
  components: {
    roleTree,
    selectSysRoleDlg,
    rolePersonTab
  },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      filterText: "",
      addSysRoleConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_ADDSYS_ROLE),
      addRoleUserConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_ADD_ROLEUSER),
      deleRoleUserConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_DELE_ROLEUSER),
      tabPosition: "权限分配",
      Skey: 0,
      selectionData: [],
      keyword: '',
      tableLoading: false,
      moduleTreeProp: {
        children: "childList"
      },
      initModuleTree: [], // 右侧初始获得的模块树
      systemAddOption: {
        roleID: "",
        $isOperation: "",
        roleName: "",
        pid: "",
        id: ""
      },
      roleType: 0,
      roleName: '',
      roleID: '',
      moduleTree: [] // 模块树
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    submitList() {
      const newarr = [];
      this.getTreeDataByFilter(this.moduleTree, newarr);
      return newarr;
    },
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initModuleTree) === JSON.stringify(this.submitList);
    },
    // 扁平化
    flatModuleList() {
      const { moduleTree } = this;
      const list = [];
      const each = childList => {
        for (const module of childList) {
          list.push(module);
          const { childList } = module;
          if (childList && childList.length > 0) each(childList);
        }
      };
      each(moduleTree);
      return list;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.roletree.filterText(val);
    },
    async tabPosition(val) {
      this.selectionData = [];
      this.Skey++;
      if (val === '成员信息') {
        await this.$nextTick(() => {});
        const data = {
          roleID: this.systemAddOption.roleID,
          roleName: this.systemAddOption.roleName
        };
        this.$refs.rolePersonTab.queryPreson(data);
      }
    },
    keyword() {
      this.comGetPersonList();
    }
  },
  methods: {
    getIndeterminate(row) {
      const { childList, isChecked } = row;
      if (childList && childList.length > 1) {
        for (const item of childList) {
          if (item.isChecked !== isChecked) return true;
        }
      }
      return false;
    },
    // 添加系统角色
    addRoleHandler() {
      const a = disablePrompt();
      if (a) {
        this.$prompt("请输入角色名称", "添加角色", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入角色名称",
          inputErrorMessage: "请输入除空格外的15文字以内的角色名称",
          inputPattern: /^\S{1,15}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: async (action, { inputValue }, done) => {
            if (action === "confirm") {
              const form = {
                roleName: inputValue,
                enterpriseId: this.enterpriseId
              };
              try {
                const result = await priviService.saveSysRole(form);
                if (result.result === "0") {
                  this.$message({ type: "success", message: "角色添加成功" });
                  this.getRoleList();
                  done();
                }
              } catch (e) {
                this.$message({ type: "error", message: "角色添加失败" });
              }
            } else {
              done();
            }
          }
        });
      }
    },
    // 向角色添加人
    async addRolePersonHandler() {
      const a = disablePrompt();
      if (a) {
        const props = {
          max: Infinity,
          codePri: ["User"]
        };
        const data = await openMember(props);
        const { systemAddOption: { roleID, roleName }} = this;
        const userList = data.map(item => {
          return {
            userId: item.userId,
            roleId: roleID,
            enterpriseId: this.enterpriseId
          };
        });
        await priviService.addSysRoleUser(userList);
        this.$message.success({ message: "添加人员成功" });
        this.$refs.rolePersonTab.queryPreson({ roleID, roleName });
      }
    },
    batchDelete() {
      if (this.selectionData.length == 0) {
        this.$message.warning("请选择要删除的人员");
        return;
      }
      const roleID = this.systemAddOption.roleID;
      const roleName = this.systemAddOption.roleName;
      const { $confirm, $message } = this;
      const userId = this.selectionData.map(item => item.userId).join(",");
      const username = this.selectionData.map(item => item.name + item.username).join(",");
      $confirm(`确定删除人员 ${username} 的角色权限?`, "警告", {
        type: "warning"
      })
        .then(() => priviService.delSysRoleUser(roleID, userId, this.enterpriseId))
        .then(() => {
          this.$refs.rolePersonTab.queryPreson({ roleID, roleName });
          $message({ type: "success", message: "批量删除角色人员成功" });
        });
    },
    search() {
      const { keyword } = this;
      this.$refs.rolePersonTab.search(keyword);
    },
    // 获取模块
    modellist(roleID) {
      this.tableLoading = true;
      const params = {
        roleId: roleID,
        businessType: this.roleType,
        enterpriseId: this.enterpriseId
      };
      priviService.queryPermissionTreeForEnterpriseCheck(params).then(({ data }) => {
        this.moduleTree = data || [];
        getTreeData(this.moduleTree);
        this.tableLoading = false;
        var list = [];
        this.getTreeDataByFilter(this.moduleTree, list);
        this.initModuleTree = JSON.parse(JSON.stringify(list));
      });
    },
    getTreeDataByFilter(data, newarr) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked === 1) {
          newarr.push({
            permissionId: data[i].permissionId,
            isParentPage: data[i].isParentPage
          });
        }
        if (data[i].childList && data[i].childList.length > 0) {
          this.getTreeDataByFilter(data[i].childList, newarr);
        }

        if (data[i].buttonList && data[i].buttonList.length > 0) {
          this.getTreeDataByFilter(data[i].buttonList, newarr);
        }
      }
      return newarr;
    },
    // 修改模块和子元素可见性
    setTreeLimit(row) {
      const { setChildrenLimit, setParentLimit } = this;
      const { isChecked, permissionId, pid, buttonList } = row;
      if (buttonList?.length) {
        buttonList.map(item => {
          item.isChecked = isChecked;
        });
      }
      setChildrenLimit(permissionId, isChecked);
      setParentLimit(pid, isChecked);
    },
    setChildrenLimit(permissionId, isChecked) {
      const { flatModuleList, setChildrenLimit } = this;
      const module = flatModuleList.find(module => permissionId === module.permissionId);
      if (module && module.childList && module.childList.length > 0) {
        for (const item of module.childList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      } else if (module && module.buttonList && module.buttonList.length > 0) {
        for (const item of module.buttonList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      }
    },
    setParentLimit(pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { setParentLimit, flatModuleList } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.childList) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.childList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    // 修改按钮和子元素可见性
    checkboxChange(row) {
      const { setbuttonParentLimit } = this;
      const { isChecked, pid } = row;
      setbuttonParentLimit(pid, isChecked);
    },
    setbuttonParentLimit(pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { flatModuleList, setParentLimit } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.buttonList && module.isChecked === 0) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.buttonList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    async copyToOtherSysRole() {
      const roleID = this.systemAddOption.roleID;
      this.$refs.selectSysRoleDlg.showDlg(roleID);
    },
    // 提交已修改模块树
    async submitModulesHandler() {
      const a = disablePrompt();
      if (a) {
        const list = this.moduleTree;
        const roleID = this.systemAddOption.roleID;
        var newarr = [];
        this.getTreeDataByFilter(list, newarr);
        const rolePermissionDetailList = newarr.map(item => {
          return {
            permissionId: item.permissionId,
            isParentPage: item.isParentPage
          };
        });
        const params = {
          enterpriseId: this.enterpriseId,
          roleId: roleID,
          rolePermissionDetailList
        };
        const res = await priviService.addRolePermission(params);
        if (res.result === "0") this.$message.success("保存成功");
        this.modellist(roleID);
        await this.$store.dispatch("GetModuleList", this.enterpriseId);
      }
    },
    setSelectionData(val) {
      this.selectionData = val;
    },
    // 删除角色下人员
    delRolePersonHandler(row) {
      const a = disablePrompt();
      if (a) {
        const roleID = this.systemAddOption.roleID;
        const roleName = this.systemAddOption.roleName;
        const { $confirm, $message } = this;
        const { userId, username, name } = row;
        $confirm(`确定删除人员 ${name}${username} 的角色权限?`, "警告", {
          type: "warning"
        })
          .then(() => priviService.delSysRoleUser(roleID, userId))
          .then(() => {
            this.$refs.rolePersonTab.queryPreson({ roleID, roleName });
            $message({ type: "success", message: "删除角色人员成功" });
          });
      }
    },
    comGetPersonList() {
      const roleID = this.systemAddOption.roleID;
      const roleName = this.systemAddOption.roleName;
      const keyword = this.keyword;
      this.$refs.rolePersonTab.queryPreson({ roleID, roleName, keyword });
    },
    empty() {
      this.moduleTree = [];
    },
    queryPreson() {
      if (this.tabPosition === '成员信息') {
        if (this.keyword === '') {
          this.comGetPersonList();
        } else {
          this.keyword = '';
        }
      }
    },
    setRoleTreeData(data) {
      this.roleType = data.roleType;
      this.roleID = data.roleID;
      this.roleName = data.roleName;
    },
    setSystemAddOption(data) {
      this.systemAddOption = data;
    },
    setLoading() {
      this.$emit('setLoading');
    },
    getRoleList() {
      this.$refs.roletree.getRoleList();
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "background: rgba(118, 137, 173, 0.04)";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.systemRole{
  width: 100%;
  height: 100%;
  overflow-x: auto;
}
</style>
<style lang="scss" scoped src="../index.scss" />
